import { render, staticRenderFns } from "./InviteTeamIcon.vue?vue&type=template&id=6396ed60&"
import script from "./InviteTeamIcon.vue?vue&type=script&lang=js&"
export * from "./InviteTeamIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports